import React from 'react'
import { HeaderWrapper, Logo } from './style'

const Header: React.FC = () => {
  return (
    <HeaderWrapper>
      <Logo>Trella</Logo>
    </HeaderWrapper>
  )
}

export default Header
